import React, { useEffect, useState } from "react";
import axios from "axios";
function NewVideoConsult(props) {
  let loginData = localStorage.getItem("login_result");
  let loginDataObject = loginData ? JSON.parse(loginData) : null;
  const { selectedPatient } = props;
  const [url, setUrl] = useState("");
  const [permissionsGranted, setPermissionsGranted] = useState(false);
  useEffect(() => {
    getLink();
  }, []);
  const getLink = () => {
    const header = {
      "Content-Type": " application/json",
      "x-secret":
        "sEjtQtHalCl22p2CEIrKz6uIaR1KENqEyG4coWIoZEDrFpLgv8sqWDprEEv2rGrlZ6igUwYbHNDHFySF",
    };

    const data = {
      license: "9ngZbjYYVrwxbubEnVdEmpePAyBTqlQkcDI1ICcV",
      roomname: selectedPatient.appointmentId,
      name: "Dr. " + `${loginDataObject.user.firstName} ` + ``,
      email: loginDataObject.user.email
        ? `${loginDataObject.user.email}`
        : "test@doc.com",
    };
    axios
      .post("https://emeet.syncdigit.co.in:31010/token/issue", data, {
        headers: header,
      })
      .then((result) => {
        setUrl(result.data.url);
        props.fetchUrl(result.data.url);
      })
      .catch((err) => {
        console.error("Err", err);
      });
  };
  if (!url) {
    return <div></div>;
  }
  return (
    <div className="">
      <div
        id="videoload"
        style={{
          width: "100px",
          height: "100px",
          margin: "auto",
          textAlign: "center",
          display: "none",
        }}
      >
        Loading...
      </div>
      <div id="videoframe" className="w-full">
        <div
          className="w-full scrollWidth"
          dangerouslySetInnerHTML={{
            __html: `<iframe 
        id="ccc" scrolling="no"
        class="w-full h-[280px] md:h-[280px] lg:h-[280px] xl:h-[280px] " 
        src="${url}" 
        allow="camera;microphone">
      </iframe>`,
          }}
        ></div>
      </div>
    </div>
  );
}

export default NewVideoConsult;
